<template>
  <div class="toggle-wrapper" :class="wrapperClasses">
    <label class="custom-toggle" :class="[switchClass, typeClass, isBoth ? 'custom-toggle-both': '']">	
      <input type="checkbox" :disabled="disabled" v-model="model">
      <span class="custom-toggle-slider rounded-circle"
            :data-label-off="offText"
            :data-label-on="onText">
      </span>
    </label>
    <span v-if="leftLabel" class="left-side-label">{{ leftLabel }}</span>
    <span class="toggle-label" :class="labelClasses">{{label}}</span>
  </div>
</template>
<script>
  export default {
    name: 'base-switch',
    props: {
      value: [Array, Boolean],
      type: String,
      label: {
        type: String,
        default: ' '
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      leftLabel: {
        type: String,
        default: ''
      },
      isBoth: {
        type: Boolean,
        default: false
      },
      labelClasses: {
        type: [String, Object],
        default: '',
        description: 'wrapper css classes'
      },
      wrapperClasses: {
        type: [String, Object],
        default: '',
        description: 'wrapper css classes'
      },
      onText: {
        type: String,
        default: ''
      },
      offText: {
        type: String,
        default: ''
      }
    },
    computed: {
      switchClass() {
        let baseClass = 'custom-toggle-';
        if (this.type) {
          return baseClass + this.type
        }
        return ''
      },
      typeClass() {
        return this.type === 'both-side';
      },
      model: {
        get() {
          return this.value;
        },
        set(value) {
          this.$emit('input', value);
        }
      }
    },
    methods: {
      triggerToggle() {
        this.model = !this.model;
      }
    }
  };
</script>
<style>
.left-side-label {
  order: -1;
  padding-right: 8px;
}
.custom-toggle-both input:not(:checked) + .custom-toggle-slider {
  border-color: #449cf9;
  background-color: #fff;
}
.custom-toggle-both input:not(:checked) + .custom-toggle-slider:before {
  background-color: #449cf9;
}
.custom-toggle-permission {
  min-width: 30%;
}
</style>
